import React from 'react';

export const GolfSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_3687)">
          <path fill-rule="evenodd" clipRule="evenodd" d="M35.7314 32C35.7314 34 34.0004 36 32.0004 36H4.00036C2.00036 36 0.193359 34 0.193359 32C0.193359 27.459 4.50836 21 18.0004 21C31.0974 21 35.7314 27.645 35.7314 32ZM19.0002 30.5C19.0002 31.8807 16.0901 33 12.5002 33C8.91039 33 6.00024 31.8807 6.00024 30.5C6.00024 29.1193 8.91039 28 12.5002 28C16.0901 28 19.0002 29.1193 19.0002 30.5Z" fill={color} />
          <path d="M10 4V30C10 30.553 10.448 30.844 11 30.844C11.552 30.844 12 30.553 12 30V4H10Z" fill={color} />
          <path d="M10 2.99924C10 0.799244 11.695 -0.395756 13.767 0.344244L23.233 3.72524C25.304 4.46524 25.304 5.67624 23.233 6.41524L13.767 9.79624C11.695 10.5372 10 9.34224 10 7.14224V2.99924Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_3687">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18935)">
        <path d="M3.99987 36H31.9999C33.9999 36 35.7309 34 35.7309 32C35.7309 27.645 31.0969 21 17.9999 21C4.50787 21 0.192871 27.459 0.192871 32C0.192871 34 1.99987 36 3.99987 36Z" fill={color} />
        <path d="M11.292 29.5001C11.292 29.5001 12.25 30.1671 13.25 30.1671C15.458 25.2921 26.25 22.6671 27.25 22.6671C27.4 22.6671 27.58 22.6491 27.762 22.6201C27.046 22.3401 26.26 22.0991 25.432 21.8831C20.806 21.9461 12.401 25.8001 11.292 29.5001Z" fill="#1AAA60" />
        <path d="M12.5 33C16.0899 33 19 31.8807 19 30.5C19 29.1193 16.0899 28 12.5 28C8.91015 28 6 29.1193 6 30.5C6 31.8807 8.91015 33 12.5 33Z" fill="#292F33" />
        <path d="M10 4V30C10 30.553 10.448 30.844 11 30.844C11.552 30.844 12 30.553 12 30V4H10Z" fill="#FFC700" />
        <path d="M10 2.99924C10 0.799244 11.695 -0.395756 13.767 0.344244L23.233 3.72524C25.304 4.46524 25.304 5.67624 23.233 6.41524L13.767 9.79624C11.695 10.5372 10 9.34224 10 7.14224V2.99924Z" fill="#FD2020" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18935">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}